export default __webpack_public_path__ + "static/media/2.02b23c57.mp3";